export enum ENotificationType {
  "InvoiceNotification" = "InvoiceNotifiacton",
  "ConfirmationConnect" = "confirmationConnect",
  "PlanSubscription" = "planSubscription",
  "SucessfullConnect" = "sucessfullConnect",
  "NoResponseConnect" = "noResponseConnect",
  "PlanSubscriptionRestored" = "planSubscriptionRestored",
  "PlanSubscriptionFailed" = "planSubscriptionFailed",
  "PlanSubscriptionSuspended" = "planSubscriptionSuspended",
  "PlanSubscriptionCancelled" = "planSubscriptionCancelled",
  "FreeTrialActivated" = "freeTrialActivated",
  "SendContactInfo" = "sendContactInfo",
  "RecievedContactInfo" = "recievedContactInfo",
  "JobScheduled" = "jobScheduled",
  "JobPunched" = "JobPunched",
  "JobRescheduled" = "jobRescheduled",
  "JobCancelled" = "jobCancelled",
  "JobInProgress" = "jobInProgress",
  "JobCompleted" = "jobCompleted",
  "JobAssigned" = "jobAssigned",
  "JobAccepted" = "jobAccepted",
  "JobDeclined" = "jobDeclined",
  "JobReminder" = "jobReminder",
  "PaypalOnboardingCompleted" = "paypalOnboardingCompleted",
  "PaypalOnboardingRevoked" = "paypalOnboardingRevoked",
  "InvoicePaid" = "invoicePaid",
  "InvoicePaidDeposit" = "invoicePaidDeposit",
  "QuoteAccepted" = "quoteAccepted",
  "WokforceDataDeletionRequest" = "wokforceDataDeletionRequest",
  "SendAdminInvitation" = "sendAdminInvitation",
  "SendWorkforceInvitation" = "sendWorkforceInvitation",
  "SendVirtualAssistantInvitation" = "SendVirtualAssistantInvitation",
  "SendAccountManagerInvitation" = "SendAccountManagerInvitation",
  "AcceptedAdminInvitation" = "acceptedAdminInvitation",
  "AcceptedWorkforceInvitation" = "acceptedWorkforceInvitation",
  "DeletedAdmin" = "deletedAdmin",
  "connectionCanceled" = "connectionCanceled",
  "AdminInvitationReceived" = "adminInvitationReceived",
  "InternalCallIncoming" = "internalCallIncoming",
  "InternalCallAccepted" = "internalCallAccepted",
  "InternalCallRejected" = "internalCallRejected",
  "InternalCallMissed" = "internalCallMissed",
  "InternalCallCanceled" = "internalCallCanceled",
  "InternalCallEnded" = "internalCallEnded",
  "InternalCallReady" = "internalCallReady",
  "InternalCallTaken" = "internalCallTaken",
  "InboundCallIncoming" = "inboundCallIncoming",
  "InboundMessageReceived" = "inboundMessageReceived",
  "InternalMessageReceived" = "internalMessageReceived",
  "InternalGroupMessageReceived" = "internalGroupMessageReceived",
  "InternalGroupMentionReceived" = "internalGroupMentionReceived",
}

export interface INotificationCreate {
  type: ENotificationType;
  message: string;
  meta?: Record<string, unknown>;
}
export interface INotification<T = Record<string, unknown>> {
  isDeleted: boolean;
  id: number;
  userUid: string | null;
  companyId: number;
  type: ENotificationType;
  message: string;
  isRead: boolean;
  meta: T;
  updatedAt: string;
  createdAt: string;
  workforceUid: string | null;
}
